export const EDIT_ACCESS_RECEIVED = 'EDIT_ACCESS_RECEIVED';
export const SET_ACCESSES_RECEIVED = 'SET_ACCESSES_RECEIVED';
export const RESET_ACCESSES_RECEIVED = 'RESET_ACCESSES_RECEIVED';

export function editAccessReceived(value) {
  return {
    type: EDIT_ACCESS_RECEIVED,
    value,
  };
}

export function setAccessesReceived(value) {
  return {
    type: SET_ACCESSES_RECEIVED,
    value,
  };
}

export function resetAccessesReceived() {
  return {
    type: RESET_ACCESSES_RECEIVED,
  };
}
